document.addEventListener("DOMContentLoaded", () => {
  const sticky = document.querySelector(".product__sticky-follow");
  const targetButton = document.querySelector("button#add");
  const buttonContainer = document.querySelector(".button-container-sticky");
  const productMain = document.querySelector(".product-main");
  const footerElement = document.querySelector("footer");

  if (!sticky || !productMain || !footerElement || !targetButton || !buttonContainer) {
    return;
  }

  function handleStickyClick(e) {
    e.preventDefault();
    targetButton.click();
  }

  const updateStickyNav = () => {
    // If the cart is open, hide the bar.
    // The original code doesn't work, even when adapted for the new sidecart; it only hides when scrolling, so it's being converted to CSS.
    // Original code:
    // null !== document.querySelector(".cart__drawer-wrap") && (document.querySelector(".cart__drawer-wrap").classList.contains("active")

    const scrollY = window.scrollY;

    // Determine if the target button is completely above the viewport.
    const isTargetAboveViewport = () => {
      if (!targetButton) return false;
      const rect = targetButton.getBoundingClientRect();
      return rect.bottom < 0;
    };

    // Determines if the target button is visible in the viewport
    const isTargetVisible = () => {
      if (!targetButton) return false;
      const rect = targetButton.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < window.innerHeight;
    };

    // Calculate the threshold for hiding the bar near the footer
    const hideAtFooterThreshold = document.body.scrollHeight - 2.5 * footerElement.clientHeight;


    // DECISION TREE
    let goIn = false;
    // Is only for mobile viewports
    window.innerWidth < 1024 ? goIn = !isTargetVisible() : goIn = isTargetAboveViewport();
    if (goIn) {
      if (scrollY > hideAtFooterThreshold) {
        // YES: near the footer, HIDE the bar
        sticky.classList.add("invisible");
        document.body.classList.remove("sticky-nav-open");
      } else {
        // NO: Show the bar
        sticky.classList.remove("invisible");
        document.body.classList.add("sticky-nav-open");

        // Update the bar content
        buttonContainer.removeEventListener("click", handleStickyClick);
        buttonContainer.addEventListener("click", handleStickyClick);
        buttonContainer.innerHTML = targetButton.innerHTML;
      }
    } else {
      // NO: hide the bar
      sticky.classList.add("invisible");
      document.body.classList.remove("sticky-nav-open");
    }
  };

  updateStickyNav();
  window.updateStickyNav = updateStickyNav;

  window.addEventListener("scroll", updateStickyNav, {
    passive: true
  });
});
